<template>
  <div class="container">
    <b-modal
        :model-value="modEditarMenu"
        :no-close-on-backdrop="true"
        hide-footer
                centered
        :title="labels.title"
        header-class="reset-modal-header"
        title-class="reset-modal-title"
        body-class="reset-modal-body"
        class="reset-password-dialog edit-menu-dialog"
     @hide="cierraModal">
        <div v-if="form.idMenu !== null" class="uniform-modal-body">
            <div class="password-policy-box mb-4">
                <div class="password-policy-title">{{ labels.infoTitle }}</div>
                <div class="password-policy-subtitle">{{ labels.infoText }}</div>
            </div>

            <!-- Campo: Nombre -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.name }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="form.nombre" 
                        type="text" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="Nombre del menú"
                    />
                </b-col>
            </b-row>

            <!-- Campo: Editar Descripcion -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.descripcion }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="form.descripcion" 
                        type="text" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="Descripcion...."
                    />
                </b-col>
            </b-row>

            <!-- Campo: Ruta -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.ruta }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="form.ruta" 
                        type="text" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="/ruta-del-menu"
                    />
                </b-col>
            </b-row>


            <!-- Campo: Icono -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.icono }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-select
                        v-model="form.icono"
                        :options="iconSelectOptions"
                        class="form-input"
                    />
                </b-col>
            </b-row>

            <!-- Campo: Orden -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.orden }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="form.orden" 
                        type="number" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="Número de orden"
                    />
                </b-col>
            </b-row>

            <!-- Botones de acción -->
            <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                <b-button class="mr-2 reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
                <b-button class="reset-btn-primary" @click="guardarMenu">{{ labels.save }}</b-button>
            </div>
        </div>
        <div v-else class="text-center mt-3">
            {{ labels.loading }}
        </div>
    </b-modal>
  </div>
</template>

<script>
import Menu from '../../../services/Menu'; 
import { getMenuIconNames } from '../../../utils/menuIconCatalog';

export default {
    name: "EditarMenu",
    props: ['modEditarMenu', 'infoMenu'],
    data: () => ({
        form: {
            idMenu: null,
            nombre: "",
            descripcion: "",
            ruta: "",
            icono: "",
            orden: ""
        },
        iconOptions: []
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar menú",
                    save: "Guardar",
                    close: "Cerrar",
                    name: "Nombre",
                    descripcion: "Descripcion",
                    ruta: "Ruta",
                    icono: "Icono",
                    roles: "Roles",
                    orden: "Orden",
                    loading: "Cargando información del menú...",
                    infoTitle: "Datos del menú",
                    infoText: "Actualiza la información y guarda los cambios."
                }
            } else {
                return {
                    title: "Edit menu",
                    save: "Save",
                    close: "Close",
                    name: "Name",
                    ruta: "Route",
                    icono: "Icon",
                    roles: "Role",
                    orden: "Order",
                    loading: "Loading menu data...",
                    infoTitle: "Menu information",
                    infoText: "Update the information and save changes."
                }
            }
        },
        iconSelectOptions() {
            const base = this.$store.state._language == "es-ES"
                ? [{ value: "", text: "Seleccione un icono" }]
                : [{ value: "", text: "Select an icon" }];
            const items = this.iconOptions.map((iconName) => ({
                value: iconName,
                text: iconName
            }));
            return [...base, ...items];
        }
    },
    watch: {
        infoMenu: {
            immediate: true,
            handler(newVal) {
                const menu = Array.isArray(newVal) && newVal.length > 0 ? newVal[0] : null;
                
                if (!menu || (typeof menu === 'object' && !Object.keys(menu).length)) {
                    this.form = {
                        idMenu: null,
                        nombre: "",
                        descripcion: "",
                        ruta: "",
                        icono: "",
                        orden: ""
                    };
                    return;
                }

                this.form = {
                    idMenu: menu.id || null,
                    nombre: menu.nombre || "",
                    descripcion: menu.descripcion || "",
                    ruta: menu.ruta || "",
                    icono: menu.icono || "",
                    orden: menu.orden || ""
                };
            }
        }
    },
    mounted() {
        this.iconOptions = getMenuIconNames();
    },
    methods: {
        cierraModal() {
            this.$emit('closeModal', false)
        },
        guardarMenu() {
            if (this.form.nombre == "") {
                this.$toast.error("Diligenciar el campo Nombre")
                return
            }
            if (this.form.descripcion == "") {
                this.$toast.error("Diligenciar el campo Descripcion")
                return
            }
            if (this.form.ruta == "") {
                this.$toast.error("Diligenciar el campo Ruta")
                return
            }
            if (this.form.icono == "") {
                this.$toast.error("Diligenciar el campo Icono")
                return
            }
            if (this.form.orden == "") {
                this.$toast.error("Diligenciar el campo Orden")
                return
            }

            const formu = {
                'idMenu': this.form.idMenu,
                'nombre': this.form.nombre,
                'descripcion': this.form.descripcion,
                'ruta': this.form.ruta,
                'icono': this.form.icono,
                'orden': this.form.orden,
                'idUser': this.$store.state.userId
            }

            Menu.updateMenuById(formu)
                .then((res) => {
                    if (res.status == 200) {
                        this.$toast.success(res.data.message)
                        this.$emit('updated', {
                            id: this.form.idMenu,
                            nombre: this.form.nombre,
                            descripcion: this.form.descripcion,
                            ruta: this.form.ruta,
                            icono: this.form.icono,
                            orden: this.form.orden
                        })
                        this.cierraModal()
                    } else if (res.status == 204) {
                        this.$toast.error("El menú ingresado ya existe")
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error("Error al actualizar el menú")
                })
        }
    }
}
</script>
